import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect, MyStore } from 'kts-platform-frame/redux';
import { create } from 'kts-scaffold-framework/utils/form';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Form, Row, Col, Input, DatePicker, Button,Select } from "antd";
 
const css = require('./index.scss');

const FormItem = Form.Item;
const Option = Select.Option;
/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class  extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 }
        };
        return (
            <Form onSubmit={this.handleSearch}>
                <Row>
                    <Col span={8}>
                        <FormItem label="创建时间" {...formItemLayout}>
                            {getFieldDecorator("createTime")(
                                <DatePicker />
                            )}
                        </FormItem>
                    </Col>
                    <Col span={8}>
                        <FormItem label="批次名称" {...formItemLayout}>
                            {getFieldDecorator("note")(<Input />)}
                        </FormItem>
                    </Col>
                    <Col span={8}>
                        <div className="pull-right">
                            <Button
                                className="mr10"
                                onClick={this.handleReset}
                            >
                                清空
                            </Button>
                            <Button type="primary" htmlType="submit">
                                筛选
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Form>
        );
    }
    private handleSearch = (e) => {
        e.preventDefault();
        console.log(21321);
        this.props.form.validateFields((err, values) => {
            const { user } = MyStore.instance.getState();
            const userId = user.userInfo.cUserId;
            const companyId = user.userInfo.companyId;
            let data = {
                ...values,
                createTime:
                    values["createTime"] &&
                    values["createTime"].format("YYYY-MM-DD"),
                pageNum: this.modulesState.listPageNumber,
                pageSize: 10,
                userId,
                companyId,
            };
            ModulesAction.updateCompareList(data);
        });
    }
    private handleReset = () => {
        this.props.form.resetFields();
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/InvoiceCompare/UI.CompareList.Filter.tsx